<template>
  <vx-card id="descontos-menu-status">
    <div class="demo-alignment mt-0">
      <vs-button
        class="mt-0"
        type="line"
        color="dark"
        :active="statusAtual(null)"
        @click="abrir(null)"
      >Todos</vs-button>
      <template v-for="(item) in menu">
        <vs-dropdown
          v-bind:key="item.slug"
          v-if="item.tipo == 'grupo'"
          vs-trigger-click
          class="mt-0 cursor-pointer"
          :active="grupoAtual(item.nome)"
        >
          <vs-button class="btn-drop" type="line" icon="expand_more" color="dark">{{ item.nome }}</vs-button>
          <vs-dropdown-menu class="descontos-menu-status-dropdown" :active="statusAtual(item.slug)">
            <vs-dropdown-item
              v-for="(subitem) in item.dados"
              v-bind:key="subitem.dados.slug"
              @click="abrir(subitem.dados.slug)"
              :active="statusAtual(subitem.dados.slug)"
            >{{ subitem.dados.nome }}</vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        <vs-button
          v-else
          class="mt-0"
          type="line"
          color="dark"
          @click="abrir(item.dados.slug)"
          :active="statusAtual(item.dados.slug)"
          v-bind:key="item.dados.slug"
        >{{ item.dados.nome }}</vs-button>
      </template>
    </div>
  </vx-card>
</template>

<script>
import {
  STATUS_DIGITANDO,
  STATUS_EM_ANALISE,
  STATUS_PENDENTES,
  STATUS_ATIVOS,
  STATUS_REVISAO,
  STATUS_CANCELADOS
} from "@constants/index";

export default {
  name: "menu-status-contrato",
  created() {
    this.$store.dispatch("FETCH_STATUS_AGRUPADO");
  },
  computed: {
    menu() {
      return this.$store.getters.getStatusAgrupado();
    }
  },
  methods: {
    statusAtual(slug) {
      return this.$route.params.status == slug;
    },
    grupoAtual(grupo) {
      return (
        this.$store.getters.getStatusAgrupado().filter(item => {
          return (
            item.tipo == "grupo" &&
            item.nome == grupo &&
            item.dados.filter(
              subitem => this.$route.params.status == subitem.dados.slug
            ).length > 0
          );
        }).length > 0
      );
    },
    abrir(slug) {
      this.$router.push({ name: "contratos", params: { status: slug } });
    },
    icon(slug) {
      switch (slug) {
        case STATUS_DIGITANDO:
          return "icon-file-text";
        case STATUS_EM_ANALISE:
          return "icon-clock";
        case STATUS_ATIVOS:
          return "icon-user-check";
        case STATUS_PENDENTES:
          return "icon-corner-up-left";
        case STATUS_REVISAO:
          return "icon-slash";
        case STATUS_CANCELADOS:
          return "icon-x";
        default:
          return "icon-list";
      }
    }
  }
};
</script>

<style lang="scss">
#descontos-menu-status .vs-button[active] .vs-button-linex,
#descontos-menu-status .vs-con-dropdown[active] .vs-button-linex {
  left: 50% !important;
  transform: translateX(-50%) !important;
  width: 100%;
}

#descontos-menu-status .vx-card__body {
  padding: 0;
}

#descontos-menu-status .vs-con-dropdown {
  margin: 0;
}

#descontos-menu-status .vs-button {
  padding: 1.5rem 2rem;
  margin: 0;
}

.descontos-menu-status-dropdown .vs-dropdown--item-link {
  padding-bottom: 0.8rem;
  padding-top: 0.8rem;
}

.descontos-menu-status-dropdown .vs-dropdown--item-link[active] {
  color: #000 !important;
}
</style>
